import React from "react";
import {
  ReferralContestCard,
  ReferralContestContainer,
} from "./ReferralContest.styled";

const ReferralContest = () => {
  return (
    <ReferralContestContainer>
      <ReferralContestCard>
        <p>Join Our Referral Contest and Win Amazing Prizes!</p>
        <p>
          Introduction: We are thrilled to announce our exciting referral
          contest where you have the opportunity to win fantastic prizes simply
          by inviting your friends, family, and colleagues to join Pubmining.
          It's time to put your networking skills to the test and earn rewards
          while helping others discover the incredible earning potential of our
          platform.
        </p>
        <h4>How it Works:</h4>
        <ul>
          <li style={{ marginBlock: "10px" }}>
            Eligibility: All Pubmining members are automatically eligible to
            participate in the referral contest. If you're not a member yet,
            sign up now to join the competition.
          </li>

          <li style={{ marginBlock: "10px" }}>
            Unique Referral Link: Each participant will receive a unique
            referral link that can be shared with others. This link will track
            the number of new members you bring to Pubmining.
          </li>

          <li style={{ marginBlock: "10px" }}>
            Spread the Word: Share your referral link through various channels
            such as social media, email, messaging apps, or direct invitations.
            Encourage your network to sign up using your link to ensure their
            registration is attributed to you.
          </li>

          <li style={{ marginBlock: "10px" }}>
            Track Your Progress: Keep an eye on your referral dashboard within
            your Pubmining account. It will display the number of successfully
            referred members and their activity on the platform.
          </li>

          <li style={{ marginBlock: "10px" }}>
            Contest Period: The referral contest will run for a specified
            duration, usually ranging from 30 to 60 days. During this time,
            invite as many people as possible to increase your chances of
            winning.
          </li>

          <li style={{ marginBlock: "10px" }}>
            Prizes: We have a range of exciting prizes lined up for the winners.
            Prizes may include bonus earnings, exclusive mining machine
            upgrades, Pubmining merchandise, or even cryptocurrency rewards. The
            more referrals you make, the higher your chances of winning.
          </li>

          <li style={{ marginBlock: "10px" }}>
            Leaderboard: A real-time leaderboard will be available on our
            website, showcasing the top referrers. This allows you to track your
            progress and see where you stand in the contest rankings.
          </li>

          <li style={{ marginBlock: "10px" }}>
            Winners Announcement: At the end of the contest period, the winners
            will be announced on our official website and social media channels.
            They will be contacted directly to claim their prizes.
          </li>
        </ul>
        <h4>Tips to Maximize Your Referrals:</h4>
        <ul>
          <li style={{ marginBlock: "10px" }}>
            Personalize Your Invitations: Craft personalized messages explaining
            the benefits of Pubmining and why they should join. Highlight the
            potential earnings and the incredible opportunity to be part of a
            thriving community.
          </li>

          <li style={{ marginBlock: "10px" }}>
            Leverage Your Network: Reach out to your friends, family,
            colleagues, and acquaintances who may be interested in
            cryptocurrency mining or seeking additional income streams. Spread
            the word through social media posts, group chats, and word-of-mouth
            recommendations.
          </li>

          <li style={{ marginBlock: "10px" }}>
            Engage with the Community: Participate actively in our Pubmining
            Telegram group, forums, and social media platforms. Share your
            success stories, answer questions, and provide support to potential
            referrals. By being an engaged member, you showcase the value of the
            platform and build trust.
          </li>

          <li style={{ marginBlock: "10px" }}>
            Stay Updated: Keep an eye on our official announcements and updates.
            We may offer bonus incentives, exclusive promotions, or additional
            perks during the contest period. Stay informed and leverage these
            opportunities to attract more referrals.
          </li>
        </ul>
        <p>
          Join our referral contest today and be part of the Pubmining success
          story! Start inviting your network and watch your earnings soar while
          standing a chance to win incredible prizes. Together, we can unlock
          the true potential of cryptocurrency mining.
        </p>
      </ReferralContestCard>
    </ReferralContestContainer>
  );
};

export default ReferralContest;
